export class DevicePeripheral {

    private active: boolean;
    private btMac: string;
    private btName: string;
    private btPassword: string;
    private comBaud: number;
    private deviceInternalId: string;
    private internalId: string;
    private peripheralConnectionPort: string;
    private peripheralConnectionType: string;
    private peripheralName: string;
    private peripheralType: string;
    private productId: string;
    private tcpIp: string;
    private vendorId: string;

    constructor(active?: boolean, btMac?: string, btName?: string, btPassword?: string, comBaud?: number, connectionPort?: string, connectionType?: string, deviceInternalId?: string, internalId?: string, peripheralConnectionPort?: string, peripheralConnectionType?: string, peripheralName?: string, peripheralType?: string, productId?: string, tcpIp?: string, vendorId?: string) {
        this.active = active;
        this.btMac = btMac;
        this.btName = btName;
        this.btPassword = btPassword;
        this.comBaud = comBaud;
        this.deviceInternalId = deviceInternalId;
        this.internalId = internalId;
        this.peripheralConnectionPort = peripheralConnectionPort;
        this.peripheralConnectionType = peripheralConnectionType;
        this.peripheralName = peripheralName;
        this.peripheralType = peripheralType;
        this.productId = productId;
        this.tcpIp = tcpIp;
        this.vendorId = vendorId;
    }

    public set Active(active) {
        this.active = active;
    }
    public set BtMac(btMac) {
        this.btMac = btMac;
    }
    public set BtName(btName) {
        this.btName = btName;
    }
    public set BtPassword(btPassword) {
        this.btPassword = btPassword;
    }
    public set ComBaud(comBaud) {
        this.comBaud = comBaud;
    }
    public set DeviceInternalId(deviceInternalId) {
        this.deviceInternalId = deviceInternalId;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set PeripheralConnectionPort(peripheralConnectionPort) {
        this.peripheralConnectionPort = peripheralConnectionPort;
    }
    public set PeripheralConnectionType(peripheralConnectionType) {
        this.peripheralConnectionType = peripheralConnectionType;
    }
    public set PeripheralName(peripheralName) {
        this.peripheralName = peripheralName;
    }
    public set PeripheralType(peripheralType) {
        this.peripheralType = peripheralType;
    }
    public set ProductId(productId) {
        this.productId = productId;
    }
    public set TcpIp(tcpIp) {
        this.tcpIp = tcpIp;
    }
    public set VendorId(vendorId) {
        this.vendorId = vendorId;
    }

    public get Active() {
        return this.active;
    }
    public get BtMac() {
        return this.btMac;
    }
    public get BtName() {
        return this.btName;
    }
    public get BtPassword() {
        return this.btPassword;
    }
    public get ComBaud() {
        return this.comBaud;
    }
    public get DeviceInternalId() {
        return this.deviceInternalId;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get PeripheralConnectionPort() {
        return this.peripheralConnectionPort;
    }
    public get PeripheralConnectionType() {
        return this.peripheralConnectionType;
    }
    public get PeripheralName() {
        return this.peripheralName;
    }
    public get PeripheralType() {
        return this.peripheralType;
    }
    public get ProductId() {
        return this.productId;
    }
    public get TcpIp() {
        return this.tcpIp;
    }
    public get VendorId() {
        return this.vendorId;
    }
}
